import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { ShockingStats } from "@/components/sections/ShockingStats";
import { EducationalVideo } from "@/components/sections/EducationalVideo";
import { Features } from "@/components/sections/Features";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { TechPipeline } from "@/components/sections/TechPipeline";
import { Science } from "@/components/sections/Science";
import { Team } from "@/components/sections/Team";
import { FundingPartners } from "@/components/sections/FundingPartners";
import { Contact } from "@/components/sections/Contact";
import { Footer } from "@/components/sections/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

const toastOptions = {
  style: {
    background: '#ffffff',
    color: '#1e293b',
    border: '1px solid #e2e8f0'
  }
};

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <ShockingStats />
      <EducationalVideo />
      <Features />
      <HowItWorks />
      <TechPipeline />
      <Science />
      <Team />
      <FundingPartners />
      <Contact />
    </main>
    <Footer />
  </>
);

// NOTE: Kidney Risk Test is built but hidden. To re-enable, see:
// /app/memory/RISK_TEST_REACTIVATION.md
function App() {
  return (
    <div className="App min-h-screen bg-gradient-to-b from-slate-50 to-white text-slate-800">
      <Toaster position="top-right" toastOptions={toastOptions} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
